<template>
    <div class="dr-topic" :class="{'sub-page': topicIndex != undefined}">
        <el-form
            :model="ruleForm"
            :rules="rules"
            :inline="true"
            ref="ruleForm"
            :label-width="$i18n.locale === 'zh-CN' ? '120px': '180px'"
            class="img-form">
            <el-form-item :label="$t('c.operatorLevel')" prop="forLevel">
                <el-select v-model="ruleForm.forLevel" :placeholder="$t('tip.operatorLevel')" style="width:220px;">
                    <el-option :label="item.value" :value="item.id" v-for="item in forLevelMenu"
                            :key="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('c.difficulty')" prop="difficulty">
                <el-select v-model="ruleForm.difficulty" :placeholder="$t('tip.difficulty')">
                    <el-option :label="item.value" :value="item.id" v-for="item in difficultyDict"
                            :key="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-row style="margin-top: 10px;margin-bottom: 22px;">
                <el-col :span="12" v-loading="loading">
                    <div class="image-show-wrap">
                        <div class="dr-canvas" ref="drcanvas">
                            <div class="dr-angles j-angles"></div>
                            <div id="canvasdr"></div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="11" style="padding-left: 30px;">
                    <div class="opr-wrap">
                        <el-button type="primary" @click="chooseImage('0')" size="small">{{$t('topic.chooseImage')}}</el-button>
                        <el-button type="primary" @click="chooseImage('2')" :disabled="!dialog.canSelectTip" size="small">{{$t('topic.insertTip')}}</el-button>
                        <el-button type="primary" @click="handleDrawerVisible" v-show="TipRenderData" size="small">{{$t('topic.tipAdjust')}}</el-button>
                    </div>
                    <div class="img-info">
                        <ul>
                            <li>
                                <label>{{$t('course.imageName')}}</label>
                                <p >{{showImgInfo.byName}}</p>
                            </li>
                            <li>
                                <label>{{$t('c.knowledgePoint')}}</label>
                                <p>{{TipRenderData ? TipRenderData.knowledgeName :showImgInfo.knowledgeName}}</p>
                            </li>
                            <li>
                                <label>{{$t('topic.imageDesc')}}</label>
                                <p>{{showImgInfo.description}}</p>
                            </li>
                        </ul>
                    </div>
                    <div class="user-desc">
                        <el-collapse>
                            <el-collapse-item :title="$t('topic.addOrEditAnalyse')" name="1" class="topic-desc">
                                <quill-editor v-model="analysisRT" ref="analysisRT"></quill-editor>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </el-col>
            </el-row>
            <el-form-item class="form-btn">
                <el-button type="primary" :disabled="saveBtnDisable" @click="save2Submit">{{$t('c.save')}}</el-button>
            </el-form-item>
        </el-form>

        <image-dialog
            :type="dialog.type"
            :dialogOpen="dialog.isImageDialogOpen"
            :initData="dialog.initData"
            :isMultiSelect="dialog.isMultiSelect"
            :viewCount="dialog.viewCount"
            :canSelectTip="dialog.canSelectTip"
            :activeTab="dialog.activeTab"
            @onSelectOver="chooseImageOver">
        </image-dialog>

        <Drawer
            :title="$t('topic.tipAdjustPanel')"
            styleWidth="300"
            :visible=drawerVisible
            :onClose=onCloseDrawer
        >
            <div class="zoom">
                <el-tag>{{$t('topic.zoom')}}</el-tag>
                <el-slider
                    v-model="zoomValue"
                    show-input
                    :min=0.5
                    :max=1.5
                    :step=0.1
                    :debounce=300
                    @change="onHandleChangeZoom"
                />
            </div>
            <div class="rotate" style="margin-top: 15px;">
                <el-tag type="success">{{$t('topic.rotate')}}</el-tag>
                <el-slider
                    v-if="!isImageAngleTwo"
                    v-model="rotateValue1"
                    show-input
                    :min=-360
                    :max=360
                    :debounce=300
                    @change="onHandleChangeRotate"
                />
                <!-- 视角二的旋转 -->
                <el-slider
                    v-if="isImageAngleTwo"
                    v-model="rotateValue2"
                    show-input
                    :min=-360
                    :max=360
                    :debounce=300
                    @change="onHandleChangeRotate"
                />
            </div>
            <div class="tip" style="margin-top: 15px;">
                <el-tag type="warning">{{$t('topic.attention')}}</el-tag>
                <p class="tip-item">{{$t('topic.tipInsertAttention1')}}</p>
                <p class="tip-item">{{$t('topic.tipInsertAttention2')}}</p>
                <p class="tip-item">{{$t('topic.tipInsertAttention3')}}</p>
            </div>
            <div class="tip-thumbnail" v-show="tipThumbnail">
                <el-tag type="info">{{$t('topic.physicalMap')}}</el-tag>
                <br>
                <img :src="tipThumbnail" alt="Tip image">
            </div>
        </Drawer>
    </div>
</template>

<script>
import Drawer from '@/pages/MapManage/Drawer'
import { mapGetters } from 'vuex';
import QuillEditor from "@/components/QuillEditor"
import api from '@/api';
import imageDialog from './ImageChoose.vue';

export default {
    /**
     * 三种状态：
     * 无topicID，添加试题；
     * 有topicID，无topicIndex，编辑试题
     * 有topicID，有topicIndex，考卷中的编辑试题
     **/
    props: {
        topicID: {},
        topicIndex: {}
    },
    components: {
        imageDialog,
        Drawer,
        QuillEditor
    },
    data() {
        return {
            loading: false,
            TipRenderData: null,
            drawerVisible: false,
            tipThumbnail: '',
            zoomValue: 1,
            rotateValue1: 0, // 视角一的旋转角度
            rotateValue2: 0, // 视角二的旋转角度
            isImageAngleTwo: false,
            ruleForm: {
                forLevel: '',
                difficulty: '',
                description: ''
            },
            rules: {
                forLevel: [
                    {required: true, message: this.$t('tip.operatorLevel'), trigger: 'change'}
                ],
                difficulty: [
                    {required: true, message: this.$t('tip.difficulty'), trigger: 'change'}
                ]
            },
            analysisRT: '',
            difficultyDict: [],
            dialog: {
                type: 4,
                isMultiSelect: false,
                isImageDialogOpen: false,
                canSelectTip: false,
                activeTab: '0',
                viewCount: 1,
                initData: {}
            },
            saveBtnDisable: true,
            // 初始化右侧图像信息
            showImgInfo: {
                byName: '',
                knowledgeName: '',
                description: ''
            },
            cascadeProp: {
                value: 'id',
                label: 'value',
                children: 'children'
            },
        }
    },
    created() {
        this.$store.dispatch('getKnowledgeMenu', {
            type: 'Image'
        });
        api.getDifficulty().then(res => {
            this.difficultyDict = res.package;
        });
    },
    mounted () {
        if (this.topicID) {
            this.initGetTopicInfo()
        }
    },
    beforeDestroy(){
        this.drInstance && this.drInstance.stopRender()
    },
    computed: {
        ...mapGetters([
            'forLevelMenu',
            'knowledgeMenu',
        ]),
    },
    methods: {
        // -tip缩放
        onHandleChangeZoom (value) {
            this.drInstance.zoomInsertTip(value)
        },
        // -tip旋转
        onHandleChangeRotate (value) {
            this.drInstance.rotateInsertTip(value)
        },
        handleDrawerVisible () {
            // 视角二
            if (this.drInstance.angleIndex === 1) {
                this.isImageAngleTwo = true
            } else {
                this.isImageAngleTwo = false
            }
            this.drawerVisible = true
        },
        onCloseDrawer () {
            this.drawerVisible = false
        },
        //选取图像
        chooseImage(activeTab) {
            this.$refs['ruleForm'].validate(valid => {
                if (valid) {
                    this.dialog.activeTab = activeTab
                    this.dialog.initData = {
                        ids: [],
                        knowledge: [],
                    };
                    this.$set(this.dialog, 'isImageDialogOpen', true)
                }
            });
        },
        //选择图像完毕
        chooseImageOver(data){
            this.$set(this.dialog, 'isImageDialogOpen', false)
            if (data.length > 0) {
                if (!this.dialog.canSelectTip) { // 不可插tip
                    this.initShowImage(data[0])
                } else {  // 可以插 tip, 显示 tip 或者更换新的图像
                    if (data[0].type === 33) {
                        this.TipRenderData = data[0]
                        if(data[0].physicalMaps){
                            this.tipThumbnail = data[0].physicalMaps.length>0 ? data[0].physicalMaps[0].url:''
                        } else {
                            this.tipThumbnail = ''
                        }
                        this.zoomValue = 1
                        this.rotateValue1 = 0
                        setTimeout(() => {
                            this.drInstance.insertTip(data[0])
                        }, 200)
                    } else {
                        this.initShowImage(data[0])
                        // 单视角转双视角，视角不一样得话，删除 tip 数据
                        if (this.TipRenderData && data[0].viewCount !== this.TipRenderData.viewCount) {
                            this.TipRenderData = null
                            this.zoomValue = 1
                            this.rotateValue1 = 0
                            this.drInstance.removeInsertTip()
                        }
                    }
                }
            }
        },
        initShowImage(data) {
            this.renderData = data
            if (data.type === 32) { // 空包
                this.dialog.canSelectTip = true
                this.dialog.viewCount = data.viewCount
            } else {
                this.dialog.canSelectTip = false
            }
            let {byName, knowledgeName, description} = data
            this.showImgInfo = {
                byName,
                knowledgeName,
                description: description || this.$t('c.notAvailable')
            }
            this.showImage(data)
        },
        getRenderOptions() {
            let DrWidth = Math.floor($('.dr-canvas').width())
            let DrHeight = Math.floor($('.dr-canvas').height())
            let loadedCallback = () => (this.loading = false)
            let options = {DrWidth, DrHeight, loadedCallback}
            return options
        },
        showImage(imgInfo) {
            this.$nextTick(() => {
                let options = this.getRenderOptions()
                this.loading = true
                if (!this.hasShowImg) {
                    this.drInstance = new DrViewer(options)
                    this.drInstance.setNeedLoadAllData(true)
                    // !控制不让用户标记图像，只看
                    this.hasShowImg = true
                    this.saveBtnDisable = false
                }
                if (imgInfo.type === 31) {
                    this.drInstance.removeInsertTip()
                    this.TipRenderData = null
                }
                this.drInstance.showDR(imgInfo)
            })
        },

        save2Submit() {
            let postData = {}
            postData.difficulty = this.ruleForm.difficulty
            postData.forLevel = this.ruleForm.forLevel
            postData.type = 5 // DR
            postData.title = ''
            postData.titleRT = ''
            postData.analysis = this.$refs.analysisRT.quill.getText()
            postData.analysisRT = this.analysisRT
            postData.luggageID = this.renderData.id
            if(this.renderData.userType == 2){
                postData.userLuggageID = this.renderData.userImageId
            }
            if (this.TipRenderData) {
                postData.tipID = this.TipRenderData.id
                if(this.TipRenderData.userType == 2){
                    postData.userTipID = this.TipRenderData.userImageId
                }
                let tipPos = this.drInstance.getInsertTipPos()
                postData.drCoordinate1 = tipPos[0]
                // *添加tip缩放和旋转的数据.视角二(若存在)的旋转角度和视角一不同
                postData.drCoordinate1[2] = this.rotateValue1
                postData.drCoordinate1[3] = this.zoomValue
                if (tipPos.length === 2) {
                    postData.drCoordinate2 = tipPos[1]
                    postData.drCoordinate2[2] = this.rotateValue2
                    postData.drCoordinate2[3] = this.zoomValue
                }
            }
            // 不可点击，防止重复点击提交
            this.saveBtnDisable = true
            if (!this.topicID) {
                api.addDrTopic(postData).then(res => {
                    this.$message.success(this.$t('m.addSuccess'));
                    this.$router.replace({name: 'myTopic'});
                }).catch(error => this.saveBtnDisable = false);
            } else {
                this.submitEditTopic(postData)
            }
        },
        /*
        *  考题编辑的逻辑
        */
        initGetTopicInfo() {
            api.getDrTopic(this.topicID).then(data => {
                let topicData = data.package
                this.saveBtnDisable = false
                this.ruleForm.forLevel = topicData.forLevel
                this.ruleForm.difficulty = topicData.difficulty
                this.ruleForm.description = topicData.analysisRT
                this.analysisRT = topicData.analysisRT

                let lug;
                if(topicData.userLuggageID){
                    lug = topicData.userLuggage
                }else{
                    lug = topicData.luggage
                }
                this.showImgInfo.byName = lug.byName
                this.showImgInfo.knowledgeName = lug.knowledgeName
                this.showImgInfo.description = lug.description
                this.dialog.canSelectTip = lug.type === 32
                this.dialog.viewCount = lug.viewCount
                this.tipThumbnail = topicData.tip?.physicalMaps?.length && topicData.tip.physicalMaps[0].url
                this.showEditTopicDR(topicData)
            })
        },
        showEditTopicDR(data) {
            if(data.userLuggageID){
                this.renderData = data.userLuggage
                this.renderData.userImageId = data.userLuggageID
                this.renderData.userType = 2
            }else{
                this.renderData = data.luggage
                this.renderData.userType = 1
            }
            this.hasShowImg = true
            this.drInstance = new DrViewer(this.getRenderOptions())
            this.drInstance.setNeedLoadAllData(true)
            this.drInstance.showDR(this.renderData)
            if (data.tip) {
                if(data.userTip){
                    this.TipRenderData = data.userTip
                    this.TipRenderData.userImageId = data.userTipID
                    this.TipRenderData.userType = 2
                }else{
                    this.TipRenderData = data.tip
                    this.TipRenderData.userType = 1
                }
                this.rotateValue1 = data.drCoordinate1[2] || 0
                this.zoomValue = data.drCoordinate1[3] || 1
                let defaultAngle2Yvalue = data.drCoordinate2 ? data.drCoordinate2[1] : 200
                // 如果存在视角二的坐标，需将视角二坐标的Y值传入，初始化设置
                setTimeout(() => {
                    this.drInstance.insertTip(this.TipRenderData, data.drCoordinate1, defaultAngle2Yvalue)
                }, 200)
                if (data.drCoordinate2 && data.drCoordinate2[2]) {
                    this.rotateValue2 = data.drCoordinate2[2]
                    this.drInstance.setDefaultRotateAngle2(this.rotateValue2)
                } else {
                    this.drInstance.setDefaultRotateAngle2(0)
                }
            }
        },
        submitEditTopic(data) {
            api.putDrTopic(this.topicID, data).then(res => {
                this.$message.success(this.$t('topic.editSaveSuccess'));

                if (this.topicIndex != undefined) {
                    api.getDrTopicInPaper(this.topicID).then(data => {
                        this.$emit('onSave', data.package, this.topicIndex);
                        this.$router.back();
                    });
                } else {
                    this.$router.replace({name: 'myTopic'});
                }
            }).catch(err => {
                this.saveBtnDisable = false
            })
        }
    },
    beforeRouteLeave(to, from, next) {
        // 通过面包屑进行返回时，URL中的:paperId和:paperType的值会消失，这里手动处理
        if (to.fullPath.indexOf(':paperId') > -1) {
            let lastPage = from.path.replace('/editDR','');
            next({ path: lastPage });
        } else {
            next();
        }
    },
}
</script>

<style lang="scss">
    @import '../../../style/const';

.dr-topic {

    .img-form {
        margin-left: -11px;
    }

    .image-show-wrap{
        width: 100%;
        height: 500px;
        border: 1px solid #ccc;
    }

    .dr-canvas {
        position: relative;
        width: 100%;
        height: 100%;
        padding-right: 6px;
        canvas {
            display: block;
        }
        .dr-angles {
            position: absolute;
            top: 10px;
            right: 15px;
            z-index: 9;

            a {
                display: inline-block;
                margin-left: 10px;
                border: 1px solid;
                cursor: pointer;
                @include button-variant($color-theme,#fff,$color-theme);
                @include button-size(5px,15px,14px,3px);
                &.active {
                    @include button-variant(#fff,$color-theme,$color-theme);
                    &:hover, &:focus {
                        background-color: $color-theme;
                    }
                }
            }
        }
    }

    .img-info {
        margin-top: 15px;
        li {
            margin-top: 8px;
            label {
                width: 70px;
                color: $c-txt;
                line-height: 40px;
                font-size: 14px;
            }
            p {
                height: 68px;
                padding: 10px 20px;
                color: #9699a2;
                border: dashed 1px #dcdcdc;
            }
        }
    }

    .tip {
        margin-bottom: 10px;
        &-item {
            margin-top: 10px;
            font-size: 12px;
            color: #666;
        }
        &-thumbnail {
            margin-top: 10px;
            width: 100%;
            img {
                margin-top: 8px;
            }
        }
    }

    .user-desc {
        margin-top: 15px;
    }

    .form-btn {
        display: block;
        text-align: center;
        button {
            padding-top: 10px;
            padding-bottom: 10px;
            width: 180px;
            border-radius: 18px;
        }
    }

    .edui-editor {
        box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.12);
    }

    .el-form-item__label {
        color: $c-txt;
    }

    .el-collapse,
    .el-collapse-item__wrap {
        border: none;
    }
    .el-collapse-item {
        border: dashed 1px #999;
        border-left: none;
        border-right: none;
    }
    .el-collapse-item__header {
        font-size: 15px;
        height: 32px;
        line-height: 32px;
        color: #999;
        text-align: center;
        border: none;
    }
    .el-collapse-item__arrow {
        float: none;
        display: inline-block;
        line-height: 32px;
    }

    .quill-editor {
        width: 80%;
        .ql-editor {
            min-height: 100px;
        }
    }

    // 作为在考卷中的子页面
    &.sub-page {
        padding: 30px 40px 10px 40px;
        background-color: #fff;
        overflow: auto;
        /deep/ .el-form {
            margin: 20px;
            padding: 20px;
            background-color: #fff;
            border: 1px solid #ebeef5;
            border-radius: 4px;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }
    }
}

</style>
